export default __webpack_public_path__ + "static/media/Planimetria_Sera.7541268a.jpg";